(ns frontend.view.settings2.surveys.timeseries.tab-preview
  (:require [common.localization :as loc]
            [common.util :as cu]
            [frontend.view.settings2.surveys.timeseries.event :as event]
            [frontend.view.settings2.surveys.timeseries.model :as model]
            [frontend.view.settings2.surveys.timeseries.sub :as sub]
            [oops.core :as oops]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [ui.components.grid.view :as grid]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn period-selectors
  [{:keys [ctx-path] :as ctx}]
  (let [{:keys [period-type options selected]} @(rf/subscribe [::sub/preview-period ctx-path])
        type-options (model/preview-period-type-options)]
    [:div
     {:class "flex flex-col gap-1"}
     [:div
      {:class "flex flex-wrap gap-4"}
      [labelled-input/view
       {:label           (loc/tr :timeseries-preview/period-type)
        :container-class "w-56 max-w-full"
        :data-type       :data.type/keyword
        :value           (cu/find-first-by :value period-type type-options)
        :options         type-options
        :on-change       (fn [v]
                           (rf/dispatch [::event/set-preview-period-type (assoc ctx :period-type v)]))}]
      [labelled-input/view
       {:label           (loc/tr :reference-period)
        :container-class "w-96 max-w-full"
        :editor-type     :editor.type/select
        :value           selected
        :options         options
        :on-change       (fn [v]
                           (rf/dispatch [::event/set-preview-period-value (assoc ctx :period-value v)]))}]]
     [:span
      {:class "text-sm text-helper-light-text"}
      (loc/tr :timeseries-preview/reference-period-hint)]]))

(defn empty-state
  [text]
  [:div
   {:class "text-sm text-helper-light-text bg-helper-light px-4 py-3"}
   text])

(defn preview-grid
  [{:keys [rows columns]}]
  [grid/ag-grid
   {:theme               grid/theme-quartz
    :columnDefs          (into [{:headerName      ""
                                 :field           :label
                                 :colId           "question"
                                 :pinned          "left"
                                 :minWidth        250
                                 :suppressMovable true}]
                               (map-indexed (fn [idx {:keys [label]}]
                                              {:headerName      label
                                               :colId           (str "period-" idx)
                                               :minWidth        120
                                               :suppressMovable true}))
                               columns)
    :rowData             rows
    :getRowId            (fn [data-js]
                           (str (oops/oget data-js "data.id")))
    :defaultColDef       {:sortable                 false
                          :editable                 false
                          :resizable                true
                          :suppressHeaderMenuButton true}
    :domLayout           "autoHeight"
    :suppressCellFocus   true
    :suppressContextMenu true}])

(defn view
  [{:keys [ctx-path] :as ctx} block]
  (r/with-let [_ (rf/dispatch [::event/init-preview ctx])]
    ;; nil for the first render, until ::init-preview has run
    (when-let [{:keys [rows columns] :as table} @(rf/subscribe [::sub/preview-table ctx-path block])]
      [:div
       {:class "flex flex-col gap-4"}
       [period-selectors ctx]
       (cond
         (empty? rows) [empty-state (loc/tr :timeseries-preview/no-questions)]
         (empty? columns) [empty-state (loc/tr :timeseries-preview/no-periods)]
         :else [preview-grid table])])))
